import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';

// Import Swiper styles
import 'swiper/css';

// Import bank logos
import bancaribe from '../assets/bancaribe.png';
import banesco from '../assets/banesco.png';
import mercantil from '../assets/mercantil.png';
import provincial from '../assets/provincial.png';
import bdv from '../assets/bdv.png';
import bnc from '../assets/bnc.png';
import bancrecer from '../assets/bancrecer.png';
import bancamiga from '../assets/bancamiga.png';
import banco100 from '../assets/100.png';
import bfc from '../assets/bfc.png';
import delsur from '../assets/delsur.png';
import plaza from '../assets/plaza.png';
import venezolano from '../assets/venezolano.png';

const BankSlider = () => {
  // Bank logos data - using imported images
  const banks = [
    {
      name: "Bancaribe",
      logo: bancaribe
    },
    {
      name: "Banesco",
      logo: banesco
    },
    {
      name: "Mercantil",
      logo: mercantil
    },
    {
      name: "BBVA Provincial",
      logo: provincial
    },
    {
      name: "BDV",
      logo: bdv
    },
    {
      name: "BNC",
      logo: bnc
    },
    {
      name: "Bancrecer",
      logo: bancrecer
    },
    {
      name: "Bancamiga",
      logo: bancamiga
    },
    {
      name: "100",
      logo: banco100
    },
    {
      name: "BFC",
      logo: bfc
    },
    {
      name: "Del Sur",
      logo: delsur
    },
    {
      name: "Plaza",
      logo: plaza
    },
    {
      name: "Venezolano",
      logo: venezolano
    }
  ];

  return (
    <div className="mt-4">
      <div className="w-100 ">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={3}
          loop={true}
          autoplay={{
            delay: 800,
            disableOnInteraction: false,
          }}
          breakpoints={{
            320: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            430: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1000: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1410: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}
        >
          {banks.map((bank, index) => (
            <SwiperSlide key={index}>
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ height: '62px' }}
              >
                <img
                  src={bank.logo}
                  alt={bank.name}
                  className="img-fluid"
                  style={{
                    maxHeight: '47px',
                    maxWidth: '124px',
                    objectFit: 'contain',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.filter = 'grayscale(0)';
                    e.target.style.transform = 'scale(1.05)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.filter = 'grayscale(0.2)';
                    e.target.style.transform = 'scale(1)';
                  }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default BankSlider;